<template>
  <div class="transcation-container">
    <p class="title-con">
      <span class="title">交易记录</span>
      <span class="num">共{{total}}条记录</span>
    </p>
    <van-list v-model="isLoading" :finished="isFinished" finished-text="没有更多了" @load="fetchData" class="list">
      <li class="item" :class="{'item-child': list.length==1}" v-for="(item, index) in list" :key="index">
        <p class="name">{{item.content}}</p>

        <p class="price-date">
          <span class="price">{{transferPrice(item.amount)}}元</span>
          <span class="date">{{item.payFinishTime}}</span>
        </p>
      </li>
    </van-list>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Transcation',
  data () {
    return {
      isLoading: false,
      isFinished: false,
      /* currentPage: 1,
      pageSize: 20, */
      list: [],
      total: 0
    }
  },
  computed: {
    ...mapGetters({
      userId: 'userId'
    })
  },
  methods: {
    transferPrice (val) {
      if (typeof val !== 'number') {
        return 0
      } else {
        return (val / 100).toFixed(2)
      }
    },
    fetchData () {
      this.isLoading = true
      this.$http('/api/member/purchase/list', {}, 'get').then(res => {
        this.isLoading = false
        if (res.code === '0000' && res.data) {
          const data = res.data
          this.total = data.total
          this.list = data.list
          this.isFinished = true
          /* if (this.currentPage === 1) {
            this.list = data.list
          } else {
            this.list = [...this.list, ...data.list]
          }
          if (this.currentPage === data.pageCount || !this.userId) {
            this.isFinished = true
          }
          this.currentPage++ */
        } else {
          this.isFinished = true
          this.$toast(res.msg)
        }
      }, err => {
        this.isFinished = true
        this.isLoading = false
        this.$toast(err)
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.transcation-container {
  .title-con {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 20px 40px;
    border-bottom: 1px solid #e4e4e4;
  }
  .title {
    font-size: 42px;
    line-height: 60px;
    font-weight: bold;
  }
  .num {
    color: #9b9b9b;
  }
  .list {
    padding-left: 40px;
  }
  .item-child {
    margin-bottom: 30px;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 5px 40px 5px 0;
    border-bottom: 1px solid #e5e5e5;

    .name {
      color: #38383c;
      font-size: 32px;
      line-height: 102px;
    }
    .price-date {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;
    }
    .date {
      margin-top: 6px;
      color: #9b9b9b;
      font-size: 20px;
      line-height: 28px;
    }
  }
}
</style>
